import { URLs } from '../config'
import http from './http'
import { objectToFormdata } from './common'

export const approval = {
    get: {
        // @Url /v1/approval/{cbidx}/electap-form-list
        electapFormList: async(params) => {
            return await http.get(
                `${URLs.approval}/${params.cbidx}/electap-form-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/approval/{cbidx}/electap-form-category
        electapFormCategory: async(params) => {
            return await http.get(
                `${URLs.approval}/${params.cbidx}/electap-form-category`, {
                    params: params
                }
            )
        },
        // @Url /v1/approval/{cbidx}/electap-form/{idx}
        electapForm: async(params) => {
            return await http.get(
                `${URLs.approval}/${params.cbidx}/electap-form/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/approval/{cbidx}/electap-form-code 코드로 폼 바로조회
        electapFormCode: async(params) => {
            return await http.get(
                `${URLs.approval}/${params.cbidx}/electap-form-code`, {
                    params: params
                }
            )
        },
        // @Url /v1/staff/{cbidx}/vacation-use 신규작성 휴가폼 조회
        vacationUse: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/vacation-use`, {
                    params: params
                }
            )
        },
        // @Url /v1/staff/{cbidx}/vacation-use/{idx} 휴가 상세조회
        vacationUseDetail: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/vacation-use/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/approval/{cbidx}/electap-document-list 결재진행현황 조회
        electapDocumentList: async(params) => {
            return await http.get(
                `${URLs.approval}/${params.cbidx}/electap-document-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/approval/{cbidx}/electap-document-list/ref
        electapDocumentRef: async(params) => {
            return await http.get(
                `${URLs.approval}/${params.cbidx}/electap-document-list/ref`, {
                    params: params
                }
            )
        },
        // @Url /v1/approval/{cbidx}/electap-document-list/recall
        electapDocumentRecall: async(params) => {
            return await http.get(
                `${URLs.approval}/${params.cbidx}/electap-document-list/recall`, {
                    params: params
                }
            )
        },
        // @Url /v1/sns-posts/{cbidx}/meeting-log-list
        meetingLogList: async(params) => {
            return await http.get(
                `${URLs.sns}/${params.cbidx}/meeting-log-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/sns-posts/{cbidx}/meeting-log
        meetingLog: async(params) => {
            return await http.get(
                `${URLs.sns}/${params.cbidx}/meeting-log`, {
                    params: params
                }
            )
        },
        // @Url /v1/sns-posts/{cbidx}/meeting-log/{idx}
        meetingLogDetail: async(params) => {
            return await http.get(
                `${URLs.sns}/${params.cbidx}/meeting-log/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/management/{cbidx}/distresses-list
        distressesList: async(params) => {
            return await http.get(
                `${URLs.management}/${params.cbidx}/distresses-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/management/{cbidx}/distresses/{idx}
        distressesDetail: async(params) => {
            return await http.get(
                `${URLs.management}/${params.cbidx}/distresses/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/sns-posts/{cbidx}/case-report-list
        caseReportList: async(params) => {
            return await http.get(
                `${URLs.sns}/${params.cbidx}/case-report-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/sns-posts/{cbidx}/case-report 신규조회
        caseReport: async(params) => {
            return await http.get(
                `${URLs.sns}/${params.cbidx}/case-report`, {
                    params: params
                }
            )
        },
        // @Url /v1/sns-posts/{cbidx}/case-report/{idx} 수정 조회
        caseReportDetail: async(params) => {
            return await http.get(
                `${URLs.sns}/${params.cbidx}/case-report/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/management/{cbidx}/sms/list
        smsList: async(params) => {
            return await http.get(
                `${URLs.management}/${params.cbidx}/sms/list`, {
                    params: params
                }
            )
        },
        // @Url /v1/management/{cbidx}/item-list
        itemList: async(params) => {
            return await http.get(
                `${URLs.management}/${params.cbidx}/item-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/management/{cbidx}/medicine-purchase/{idx}
        medicinePurchase: async(params) => {
            return await http.get(
                `${URLs.management}/${params.cbidx}/medicine-purchase/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/management/{cbidx}/item-usage-list/{idx}
        itemUsageList: async(params) => {
            return await http.get(
                `${URLs.management}/${params.cbidx}/item-usage-list/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/search-synthesis-report
        searchSynthesisReport: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/search-synthesis-report`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/reward-list
        rewardList: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/reward-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/sns-posts/{cbidx}/reward/{idx}
        rewardDetail: async(params) => {
            return await http.get(
                `${URLs.sns}/${params.cbidx}/reward/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/sns-posts/{cbidx}/reward
        reward: async(params) => {
            return await http.get(
                `${URLs.sns}/${params.cbidx}/reward`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/resign
        resign: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/resign`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/resign/{idx}
        resignDetail: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/resign/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/payment/history
        paymentHistory: async(params) => {
            return await http.get(
                `${URLs.payment}/history`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/staff-commute-calendar-print
        staffCommutePrint: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/staff-commute-calendar-print`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/staff-commute-calendar
        staffCommuteList: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/staff-commute-calendar`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/commute-approval
        commuteApproval: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/commute-approval`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/commute-approval/{idx}
        commuteApprovalDetail: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/commute-approval/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/approval/{cbidx}/common-document
        commonDocument: async(params) => {
            return await http.get(
                `${URLs.approval}/${params.cbidx}/common-document`, {
                    params: params
                }
            )
        },
        // @Url /v1/approval/{cbidx}/common-document/{idx}
        commonDocumentDetail: async(params) => {
            return await http.get(
                `${URLs.approval}/${params.cbidx}/common-document/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/approval/{cbidx}/payslip-close
        payslipClose: async(params) => {
            return await http.get(
                `${URLs.approval}/${params.cbidx}/payslip-close`, {
                    params: params
                }
            )
        },
        // @Url /v1/approval/{cbidx}/payslip-close/{idx}
        payslipCloseDetail: async(params) => {
            return await http.get(
                `${URLs.approval}/${params.cbidx}/payslip-close/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/management/{cbidx}/dash
        managementDash: async(params) => {
            return await http.get(
                `${URLs.management}/${params.cbidx}/dash`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/{cbidx}/receiver-goal
        receiverGoal: async(params) => {
            return await http.get(
                `${URLs.customer}/${params.cbidx}/receiver-goal`, {
                    params: params
                }
            )
        },
        // @Url /v1/management/{cbidx}/dash-useday
        dashUseday: async(params) => {
            return await http.get(
                `${URLs.management}/${params.cbidx}/dash-useday`, {
                    params: params
                }
            )
        },
        // @Url /v1/management/{cbidx}/dash-limit
        dashLimit: async(params) => {
            return await http.get(
                `${URLs.management}/${params.cbidx}/dash-limit`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/resign-print/{idx}
        resignPrint: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/resign-print/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/sns-posts/{cbidx}/meeting-log-print/{idx}
        meetingLogPrint: async(params) => {
            return await http.get(
                `${URLs.sns}/${params.cbidx}/meeting-log-print/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/{cbidx}/staff-education
        staffEducation: async(params) => {
            return await http.get(
                `${URLs.customer}/${params.cbidx}/staff-education`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/{cbidx}/staff-education/{idx}
        staffEducationDetail: async(params) => {
            return await http.get(
                `${URLs.customer}/${params.cbidx}/staff-education/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/approval/{cbidx}/common-document-print/{idx}
        commonDocumentPrint: async(params) => {
            return await http.get(
                `${URLs.approval}/${params.cbidx}/common-document-print/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/sns-posts/{cbidx}/case-report-print/{idx}
        caseReportPrint: async(params) => {
            return await http.get(
                `${URLs.sns}/${params.cbidx}/case-report-print/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/vacation-use-print/{idx}
        vacationUsePrint: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/vacation-use-print/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/{cbidx}/staff-education-print/{idx}
        staffEducationPrint: async(params) => {
            return await http.get(
                `${URLs.customer}/${params.cbidx}/staff-education-print/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/sns-posts/{cbidx}/reward-print/{idx}
        rewardPrint: async(params) => {
            return await http.get(
                `${URLs.sns}/${params.cbidx}/reward-print/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/management/{cbidx}/distresses-print/{idx}
        distressPrint: async(params) => {
            return await http.get(
                `${URLs.management}/${params.cbidx}/distresses-print/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/{cbidx}/staff-education-list
        staffEducationList: async(params) => {
            return await http.get(
                `${URLs.customer}/${params.cbidx}/staff-education-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/edu-file-list
        eduFileList: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/edu-file-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/approval/{cbidx}/common-document-template
        commonDocumentTemplate: async (params) => {
            return await http.get(
                `${URLs.approval}/${params.cbidx}/common-document-template`, {
                    params: params
                }
            )
        },
        // @Url /v1/approval/{cbidx}/day-report
        dayReport: async (params) => {
            return await http.get(
                `${URLs.approval}/${params.cbidx}/day-report`, {
                    params: params
                }
            )
        },
        // @Url /v1/approval/{cbidx}/day-report/{idx}
        dayReportDetail: async (params) => {
            return await http.get(
                `${URLs.approval}/${params.cbidx}/day-report/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/approval/{cbidx}/item-list
        approvalItemList: async (params) => {
            return await http.get(
                `${URLs.approval}/${params.cbidx}/item-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/approval/{cbidx}/item-list/{idx}
        itemListDetail: async (params) => {
            return await http.get(
                `${URLs.approval}/${params.cbidx}/item-list/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/management/{cbidx}/steering-committee
        steeringCommittee: async (params) => {
            return await http.get(
                `${URLs.management}/${params.cbidx}/steering-committee`, {
                    params: params
                }
            )
        },
        // @Url /v1/management/{cbidx}/steering-committee/{idx}
        steeringCommitteeDetail: async (params) => {
            return await http.get(
                `${URLs.management}/${params.cbidx}/steering-committee/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/management/{cbidx}/steering-committee-list
        steeringCommitteeList: async(params) => {
            return await http.get(
                `${URLs.management}/${params.cbidx}/steering-committee-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/management/{cbidx}/steering-committee-print/{idx}
        steeringCommitteePrint: async(params) => {
            return await http.get(
                `${URLs.management}/${params.cbidx}/steering-committee-print/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/approval/{cbidx}/item-list-print/{idx}
        itemListPrint: async(params) => {
            return await http.get(
                `${URLs.approval}/${params.cbidx}/item-list-print/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/emergency-report
        emergencyReport: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/emergency-report`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/emergency-report/{idx}
        emergencyDetail: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/emergency-report/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/emergency-report-print/{idx}
        emergencyPrint: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/emergency-report-print/${params.idx}`, {
                    params: params
                }
            )
        }
    },
    post: {
        // @Url /v1/approval/{cbidx}/re-approval/{idx}
        reApproval: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.approval}/${params.cbidx}/re-approval/${params.idx}`, formData
            )
        },
        // @Url /v1/approval/{cbidx}/electap-form/{idx}
        electapForm: async(params) => {
            return await http.post(
                `${URLs.approval}/${params.cbidx}/electap-form/${params.idx}`,
                params, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/vacation-use
        vacationUse: async(params) => {
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/vacation-use`,
                params.staffVacationUseDTO, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/approval/{cbidx}/electap-document-file 결재문서 첨부파일 추가
        electapDocumentFile: async(params) => {
            let formData = objectToFormdata(params)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.approval}/${params.cbidx}/electap-document-file`, formData
            )
        },
        // @Url /v1/approval/{cbidx}/electap-document-comment 결재문서 의견등록
        electapDocumentComment: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.approval}/${params.cbidx}/electap-document-comment`, formData
            )
        },
        // @Url /v1/approval/{cbidx}/sign-document/{idx}
        signDocument: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.approval}/${params.cbidx}/sign-document/${params.idx}`, formData
            )
        },
        // @Url /v1/approval/{cbidx}/electap-document-recall/{idx}
        electapDocumentRecall: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.approval}/${params.cbidx}/electap-document-recall/${params.idx}`, formData
            )
        },
        // @Url /v1/sns-posts/{cbidx}/meeting-log
        meetingLog: async(params) => {
            return await http.post(
                `${URLs.sns}/${params.cbidx}/meeting-log`,
                params.snsPostDTO, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/management/{cbidx}/distresses
        distresses: async(params) => {
            return await http.post(
                `${URLs.management}/${params.cbidx}/distresses`,
                params.distressDTO, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/sns-posts/{cbidx}/case-report
        caseReport: async(params) => {
            return await http.post(
                `${URLs.sns}/${params.cbidx}/case-report`,
                params.snsPostDTO, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/management/{cbidx}/medicine-purchase
        medicinePurchase: async(params) => {
            return await http.post(
                `${URLs.management}/${params.cbidx}/medicine-purchase`,
                params.medicinePurchaseDTO, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/sns-posts/{cbidx}/reward-post
        reward: async(params) => {
            return await http.post(
                `${URLs.sns}/${params.cbidx}/reward-post`,
                params.snsPostDTO, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/resign
        resign: async(params) => {
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/resign`,
                params.staffResignApplyDTO, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/vacation-use-quick
        vacationUseQuick: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/vacation-use-quick`, formData
            )
        },
        // @Url /v1/payment/refund/{idx}
        refund: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/refund/${params.idx}`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/new-staff-commute-day
        staffCommuteDay: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/new-staff-commute-day`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/request-commute/{idx} 
        requestCommute: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/request-commute/${params.idx}`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/commute-close-day
        commuteCloseDay: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/commute-close-day`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/commute-approval
        commuteApproval: async(params) => {
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/commute-approval`,
                params.staffCommuteApprovalDTO, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/approval/{cbidx}/common-document
        commonDocument: async(params) => {
            return await http.post(
                `${URLs.approval}/${params.cbidx}/common-document`,
                params.commonElectapDocumentDTO, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/approval/{cbidx}/day-report
        dayReport: async(params) => {
            return await http.post(
                `${URLs.approval}/${params.cbidx}/day-report`,
                params.commonElectapDocumentDTO, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/approval/{cbidx}/item-list
        itemList: async(params) => {
            return await http.post(
                `${URLs.approval}/${params.cbidx}/item-list`,
                params.electapDocumentDTO, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/approval/{cbidx}/payslip-close
        payslipClose: async(params) => {
            return await http.post(
                `${URLs.approval}/${params.cbidx}/payslip-close`,
                params.staffPayslipCloseDTO, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/customers/{cbidx}/receiver-goal
        receiverGoal: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.customer}/${params.cbidx}/receiver-goal`, formData
            )
        },
        // @Url /v1/customers/{cbidx}/staff-education
        staffEducation: async(params) => {
            return await http.post(
                `${URLs.customer}/${params.cbidx}/staff-education`,
                params.staffEducationDTO, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/sns-posts/{cbidx}/push-meeting-one/{luidx}
        pushMeetingOne: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.sns}/${params.cbidx}/push-meeting-one/${params.luidx}`, formData
            )
        },
        // @Url /v1/sns-posts/{cbidx}/reward-push/{idx}
        rewardPush: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.sns}/${params.cbidx}/reward-push/${params.idx}`, formData
            )
        },
        // @Url /v1/sns-posts/{cbidx}/meeting-attend/{luidx}
        meetingAttend: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.sns}/${params.cbidx}/meeting-attend/${params.luidx}`, formData
            )
        },
        // @Url /v1/sns-posts/{cbidx}/meeting-log/staff-add
        mettingLogStaffAdd: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.sns}/${params.cbidx}/meeting-log/staff-add`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/file-upload/{idx}
        fileUpload: async(params) => {
            let formData = objectToFormdata(params)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/file-upload/${params.idx}`, formData
            )
        },
        // @Url /v1/management/{cbidx}/steering-committee
        steeringCommittee: async(params) => {
            return await http.post(
                `${URLs.management}/${params.cbidx}/steering-committee`,
                params.steeringCommitteeMinuteDTO, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/emergency-report
        emergencyReport: async(params) => {
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/emergency-report`,
                params.emergencyDTO, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
    },
    delete: {
        // @Url /v1/approval/{cbidx}/electap-form-approval-line/{idx}
        approvalLine: async(params) => {
            return await http.delete(
                `${URLs.approval}/${params.cbidx}/electap-form-approval-line/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/approval/{cbidx}/electap-arbiter/{idx}
        electapArbiter: async(params) => {
            return await http.delete(
                `${URLs.approval}/${params.cbidx}/electap-arbiter/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/approval/{cbidx}/electap-document-comment/{idx}
        electapDocumentComment: async(params) => {
            return await http.delete(
                `${URLs.approval}/${params.cbidx}/electap-document-comment/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/vacation-use/{idx}
        vacationUse: async(params) => {
            return await http.delete(
                `${URLs.staffs}/${params.cbidx}/vacation-use/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/management/{cbidx}/medicine-purchase/{idx}
        medicinePurchase: async(params) => {
            return await http.delete(
                `${URLs.management}/${params.cbidx}/medicine-purchase/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/approval/{cbidx}/electap-document/{idx}
        electapDocument: async(params) => {
            return await http.delete(
                `${URLs.approval}/${params.cbidx}/electap-document/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/{cbidx}/receiver-goal
        receiverGoal: async(params) => {
            return await http.delete(
                `${URLs.customer}/${params.cbidx}/receiver-goal`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/staff-commute/{idx}
        staffCommute: async(params) => {
            return await http.delete(
                `${URLs.staffs}/${params.cbidx}/staff-commute/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/sns-posts/{cbidx}/meeting-attend/{idx}
        meetingAttend: async(params) => {
            return await http.delete(
                `${URLs.sns}/${params.cbidx}/meeting-attend/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/request-commute/{idx}
        requestCommute: async(params) => {
            return await http.delete(
                `${URLs.staffs}/${params.data.cbidx}/request-commute/${params.data.idx}`, {
                    params: params.data
                }
            )
        },
        // @Url /v1/approval/{cbidx}/electap-document-end/{idx}
        electapDocumentEnd: async(params) => {
            return await http.delete(
                `${URLs.approval}/${params.cbidx}/electap-document-end/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/sns-posts/{cbidx}/reward-staff
        rewardStaff: async(params) => {
            return await http.delete(
                `${URLs.sns}/${params.cbidx}/reward-staff`, {
                    params: params
                }
            )
        }

    }
}


// WEBPACK FOOTER //
// ./src/api/approval.js